import { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import { useDeviceType } from '~/common/hooks/useDeviceQuery'
import { DossSignalType, useDossSignals } from '~/common/hooks/useDossSignals'
import { useGlobalContext } from '~/common/hooks/useGlobalContext'
import { usePage } from '~/common/hooks/usePage'
import { BottomNav } from './BottomNav'
import { MobileNav } from './MobileNav'

/**
 * Renders the mobile navigation components for the application.
 * Desktop navigation is now handled by the LeftNav component.
 */
export const Navigation = ({
  isUnauthenticatedSharedRoute,
}: {
  isUnauthenticatedSharedRoute: boolean
}) => {
  const { isMobile } = useDeviceType()
  const { user } = useGlobalContext()
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const { subscribe, unsubscribe } = useDossSignals()
  const { pathname } = useLocation()

  const { pageType } = usePage()

  const isAuthPage = pathname && (pathname === '/auth/login' || pathname === '/auth/sign-up')
  const showBottomNavigation =
    isMobile &&
    pageType !== 'form' &&
    pageType !== 'formSettings' &&
    pageType !== 'createForm' &&
    !isAuthPage &&
    pageType !== 'record'

  // Subscribe to the TOGGLE_MOBILE_MENU signal
  useEffect(() => {
    const toggleMenuSubscription = subscribe(DossSignalType.TOGGLE_MOBILE_MENU, async () => {
      setMobileMenuOpen((prev) => !prev)
    })

    return () => {
      unsubscribe(toggleMenuSubscription)
    }
  }, [subscribe, unsubscribe])

  // Only render mobile navigation components
  if (!isMobile) {
    return null
  }

  return (
    <nav className="static z-[1201] flex w-full flex-col">
      {/* Full-screen Mobile Navigation */}
      {mobileMenuOpen && !isUnauthenticatedSharedRoute && <MobileNav />}
      {showBottomNavigation && !isUnauthenticatedSharedRoute && user && <BottomNav />}
    </nav>
  )
}
